









import { Component, Vue } from 'vue-property-decorator';
import tasksTable from '@/modules/shared/tasks/components/tasksTable.vue';
import cCard from '@/components/default/Card.vue';

@Component({
  components: {
    tasksTable,
    cCard,
  },
})
export default class TasksPage extends Vue {

}
